import type { Cashier, PayoutMethodEnum, AdditionDeductionTransactionType } from '@/generated/graphql';

import { IUser, mapGQLUser } from './user';

export interface ICashier {
  id: string;
  firstName: string;
  lastName: string;
  contactNumber: string;
  createdAt: string;
  updatedAt: string;

  user: IUser;
  cashBalance: number;
}

export interface ICashierTable {
  id: string;
  firstName: string;
  lastName: string;
  name: string;
  username: string;
  contactNumber: string;
  isDisabled: boolean;

  cashBalance: number;
}

export interface ICashierQueryVariable {
  first: number;
  after?: string;
  before?: string;
}

export function mapGQLCashier(gql_cashier?: Cashier | null): ICashier {
  return {
    id: gql_cashier?.id ?? '',
    firstName: gql_cashier ? gql_cashier.firstName ?? '' : '',
    lastName: gql_cashier ? gql_cashier.lastName ?? '' : '',
    contactNumber: gql_cashier ? gql_cashier.contactNumber ?? '' : '',
    cashBalance: gql_cashier ? gql_cashier.cashBalance ?? 0 : 0,

    updatedAt: gql_cashier ? gql_cashier.updatedAt ?? new Date().toISOString() : new Date().toISOString(),
    user: mapGQLUser(gql_cashier?.user),
    createdAt: gql_cashier
      ? new Date(gql_cashier.createdAt).toLocaleString('en-US', {
          timeZone: 'Asia/Manila',
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour12: true,
          minute: '2-digit',
          hour: '2-digit',
        }) ?? ''
      : '',
  };
}

export interface IManagerCashierCashInput {
  amount: string;
  cashierId: string;
  type: 'transfer' | 'withdrawal';
}

export interface IManagerCashiersChipsInput {
  amount: string;
  type: 'transfer' | 'withdrawal';
}

export interface IEditCashierInput {
  firstName: string;
  lastName: string;
  contactNumber: string;
  username: string;
}

export interface IEditCashierPasswordInput {
  newPassword: string;
  confirmPassword: string;
}

export interface IConfirmPendingAdditionInput {
  notes: string;
  referenceId: string;
  transactionType: AdditionDeductionTransactionType;
  receiverAccountNumber: string;
}

export interface IConfirmPendingWithdrawalInput {
  notes: string;
  referenceId: string;
  senderAccountNumber: string;
}

export interface IAddCashierInput {
  firstName: string;
  lastName: string;
  contactNumber: string;
  username: string;
  password: string;
}
